export default "__VITE_ASSET__B6B7CNT___"